<app-table-filter [filtersTogglesInOnBtn]="true" [inGlobalFilter]="true" color="accent" #filter>
    <app-table-search [inGlobalFilter]="true" class="align-space" searchFilterRef></app-table-search>
    <app-tag-chip-search-filter
        [inGlobalFilter]="true"
        [languageChange]="langFilter.filterChange"
        fxFlex="50%"
        fxFlex.lt-md="100%"
        fxLayoutAlign="start"
        tagsFilterRef
    ></app-tag-chip-search-filter>
    <app-select-filter
        [inGlobalFilter]="true"
        class="filter-space"
        label="Filter by selection"
        i18n-label="@@filterBySelection"
        [property]="GlobalFilterProperty.SELECTED"
        [options]="itemSelectedOptions"
        selectedItemsRef
    >
    </app-select-filter>
    <app-language-filter
        [inGlobalFilter]="true"
        #langFilter
        fxFlex="0 0 auto"
        fxLayout="row"
        langFilterRef
    ></app-language-filter>
</app-table-filter>
<div fxLayoutAlign="start center" fxLayoutGap="10px" class="selection-Info">
    <div fxLayoutAlign="start center" fxLayoutGap="5px" class="main">
        <span i18n="@@numerOfClients">Number of clients:</span>
        <span class="total">{{ total }}</span>
    </div>
    <div fxLayoutAlign="start center" fxLayoutGap="5px" class="selected" *ngIf="selected">
        <span class="selectedNu" i18n="@@selected">Selected:</span>
        {{ selected }}
    </div>
</div>
<!-- <app-table-filter #filter>
        <mat-toolbar class="compact" fxLayout="row">
            <app-table-search></app-table-search>
        </mat-toolbar>

        <app-table-date-filter class="ml-1"></app-table-date-filter>

        <mat-toolbar color="accent" class="compact" fxLayout="row" fxFlexAlign="space-between" fxLayoutGap="0.5em">
            <span i18n="@@numerOfClients">Number of clients:</span>
            {{ total }}
            <ng-container *ngIf="selected">
                <div fxFlex="0 0 1em"></div>
                <span i18n="@@selected">Selected:</span>&nbsp;
                {{ selected }}
            </ng-container>
            <app-checkbox-filter
                [stateFilter]="{
                    property: 'select',
                    state: null,
                    neutralFilter: null,
                    activeFilter: [1],
                    notActiveFilter: [0]
                }"
                title="Filter by selected"
                i18n-title="@@filterBySelected"
            ></app-checkbox-filter>
            <div fxFlex="1 1 100%"></div>
            <app-table-menu
                matTooltip="Show all"
                (click)="filter.selectAll()"
                [columns]="columns"
                #tableMenu
                i18n-matTooltip
            ></app-table-menu>
        </mat-toolbar>
    </app-table-filter> -->

<mat-progress-bar
    class="progress progress-table-loader"
    *ngIf="(dataSource.status | async) === 'loading'"
    mode="indeterminate"
>
</mat-progress-bar>

<mat-table #table [dataSource]="dataSource" matSort matSortActive="checked">
    <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef>
            <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="masterToggle()"
                [checked]="isChecked()"
                [indeterminate]="isIndeterminate()"
            >
            </mat-checkbox>
        </mat-header-cell>
        <mat-cell *matCellDef="let customer">
            <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="selectToggle(customer)"
                [checked]="modelChecked(customer)"
            >
            </mat-checkbox>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@name"> Name </mat-header-cell>
        <mat-cell *matCellDef="let customer">{{ customer.name }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="tools">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@tools"> Tools </mat-header-cell>
        <mat-cell *matCellDef="let customer">
            <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
                <button
                    class="tools-btn green-mobile edit"
                    mat-icon-button
                    (click)="$event.stopPropagation(); editCustomer(customer)"
                    matTooltip="Edit"
                    i18n-matTooltip="@@edit"
                >
                    <mat-icon>edit</mat-icon>
                </button>

                <button
                    *ngIf="!!customerId && modelSpecs.includes(AppScope.RESOURCES)"
                    [disabled]="!modelChecked(customer)"
                    class="tools-btn green-mobile"
                    mat-icon-button
                    (click)="$event.stopPropagation(); specifyCustomerResources(customer)"
                    matTooltip="Specify Resources"
                    i18n-matTooltip="@@specifyResources"
                >
                    <mat-icon>checklist</mat-icon>
                </button>
                <button
                    *ngIf="!!customerId && modelSpecs.includes(AppScope.SECTIONS)"
                    [disabled]="!modelChecked(customer)"
                    class="tools-btn green-mobile"
                    mat-icon-button
                    (click)="$event.stopPropagation(); specifyCustomerSections(customer)"
                    matTooltip="Specify Sections"
                    i18n-matTooltip="@@specifySections"
                >
                    <mat-icon> widgets </mat-icon>
                </button>
            </div>
        </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
    <mat-row
        (click)="$event.stopPropagation(); selectToggle(customer)"
        *matRowDef="let customer; columns: columns"
    ></mat-row>
</mat-table>
<mat-paginator [pageSize]="25" [pageSizeOptions]="[25, 50, 100]"> </mat-paginator>
